import { client } from "../client";

export const markAsRead = async ({ id }: { id: number | string | undefined }) => {
  if (id === undefined) {
    return
  }
  const response = await client.patch(`/notifications/${id}/mark/read`);
  return response.data;
};

export const markAsUnread = async ({ id }: { id: number | string | undefined }) => {
  if (id === undefined) {
    return
  }
  const response = await client.patch(`/notifications/${id}/mark/unread`);
  return response.data;
};